import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-dc39113e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pa-16",
  style: {"width":"-webkit-fill-available"},
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuLayout = _resolveComponent("MenuLayout")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return _withDirectives((_openBlock(), _createBlock(_component_a_layout_sider, {
    breakpoint: "lg",
    "collapsed-width": "0",
    onCollapse: _ctx.onCollapse,
    onBreakpoint: _ctx.onBreakpoint,
    collapsed: _ctx.isCollapsed,
    "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCollapsed) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: `/` }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_MenuLayout, {
        mode: 'inline',
        menuItems: _ctx.menuItems
      }, null, 8, ["menuItems"])
    ]),
    _: 1
  }, 8, ["onCollapse", "onBreakpoint", "collapsed"])), [
    [_vShow, _ctx.showSider]
  ])
}